import { render } from "./AuthBrandPanel.vue?vue&type=template&id=46ff1e24&scoped=true"
const script = {}

import "./AuthBrandPanel.vue?vue&type=style&index=0&id=46ff1e24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ff1e24"]])

export default __exports__